import React from "react";
import "./styles.css"

const HEADER_DESCRIPTIONS = {
  HP: "Horas Paradas",
  MP: "Molde - Status do Molde",
  PP: "Peça - Pendência da Peça",
  RP: "Reprocesso",
  BS: "Base",
  V: "Peça já está em um vagão",
  OP: "Ordem da Peça (Serial)",
  PEÇA: "Código da Peça",
  "BOMBA A/B/C": "Valores das Bombas A, B e C",
  PRODUTO: "Sub-produto",
  VEÍCULO: "Veículo",
  P: "Pendência",
  MV: "Mover ou Trocar peça entre vagões",
  TR: "Trocar peça com outra",
  X: "Remover peça",
  JOGOS: "Quantidade de jogos (m² / 4.5)",
  FÓRMULA: "Código da Fórmula",
  BOMBA: "Bomba B",
};

export const WagonTableHeader = ({ header }) => {
  const description = HEADER_DESCRIPTIONS[header];
  return (
    <th className="py-0">
      {description ? (
        <span data-tooltip={description} style={{ cursor: "help" }}>
          {header}
        </span>
      ) : (
        header
      )}
    </th>
  );
}
